import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ForgotPasswordRequestPage, CustomBrandLogo } from "@ippon/shared-auth";
import { api, type ApiError } from "@ippon/shared-utils";
import { rememberOriginServiceId } from "@/utils/originService";

const CheckMail: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  // 他アプリ(物件管理等)から委譲されて来た場合、遷移元 service_id を保持し
  // フロー完了後(ResetSuccess)に元アプリのログインへ戻せるようにする。
  useEffect(() => {
    rememberOriginServiceId(searchParams.get("service_id"));
  }, [searchParams]);

  return (
    <ForgotPasswordRequestPage
      renderLogo={<CustomBrandLogo />}
      loading={loading}
      onSubmit={async ({ email }) => {
        setLoading(true);
        try {
          const res = await api.post("/auth/check-mail", { email });
          if (res.status === 200) {
            localStorage.setItem("email", email);
            navigate("/otp", { replace: true });
            return { ok: true };
          }
          return {
            ok: false,
            message: "メールアドレスが見つかりません",
          };
        } catch (e) {
          const err = e as ApiError;
          return { ok: false, message: err.message };
        } finally {
          setLoading(false);
        }
      }}
    />
  );
};

export default CheckMail;
